export default {
  seat: {
    parenthesis: '（{{text}}）',
    header: {
      station: '请输入订购信息',
      seat: '请选择座位',
      start: '{{time}}出发',
      confirm: '确认',
      seatConfirm: '座位确认',
      reserveConfirm: '预约内容确认',
      changeConfirm: '预约变更内容确认',
      bookingConfirm: '※仅在支付完成且预订完成后，座位才会正式确认。'
    },
    button: {
      back: '回退',
      prev: '上一步',
      next: '下一步',
      change: '变更'
    },
    confirmCommon: {
      noticeTitle: '座位确认',
      notice1: '※预约完成或变更手续完成后才会正式确保座位。',
      notice2: '当前座位尚未确保。',
      outbound: '去程',
      inbound: '返程',
      seatLine: '{{carNo}}号车厢-{{seatNo}}',
      departureStation: '{{station}}出发',
      arrivalStation: '{{station}}到达'
    },
    confirmChange: {
      instruction: '如内容无误，请点击「变更」。',
      contentLabel: '变更内容',
      before: '变更前',
      after: '变更后',
      noChange: '无变更'
    },
    confirmReserve: {
      contentLabel: '预约内容'
    },
    selectSeatType: {
      title: '选位方法',
      auto: '电脑选位',
      manual: '自行选位'
    },
    station: {
      date: '乘车日',
      startStation: '出发站',
      endStation: '抵达站',
      selectTip: '请选择{{name}}'
    },
    train: {
      header: '请选择小火车',
      emptySeat: '空座位',
      wheelchairAvailable: '轮椅空间可用',
      wheelchairUnavailable: '轮椅空间不可用',
      noTrains: '没有可购买的列车。请确认运行信息。',
      trainLabel: '{{trainName}}{{trainServiceNo}}号'
    },
    carriage: {
      carriageCar: '{{carNo}}号车厢',
      directionUpTitle: '↑ 往宇奈月方向',
      directionDownTitle: '↑ 往欅平方向',
      conductor: '乘务员席'
    },
    wheelchairConfirm: {
      title: '您已选择轮椅专用空间。',
      content: '此空间为轮椅乘客专用。',
      notice1: '每2个轮椅位最多可陪同1人。',
      confirmText: '是否要继续选择？',
      cancel: '取消',
      confirm: '确定'
    }
  },
  error: {
    invalidParams: '指定的条件有误。请从头重新操作',
    invalidDate: '无法选择该日期',
    lineIdInvalid: '未选择线路。请从头重新操作',
    productIdInvalid: '选择的车厢类型不正确。 请您从头开始重新操作',
    forbidden: '此操作不允许。请从头重新操作',
    notUpdatable: '该预约当前无法变更。请从头重新操作',
    notFound: '找不到页面。请从头重新操作',
    notFoundTitle: '页面未找到。',
    notFoundDescription: '请确认 URL 是否正确。',
    systemError: '系统错误。 请稍后再试'
  }
};
